import { useDxReportDrafts } from '../../../hooks/useDxReportDrafts';
import { CountPill } from './CountTabLabel';

interface DxTabLabelProps {
    patientId: string;
    /** Final review notes waiting on the Dx; shown as a yellow count. */
    noteCount?: number;
}

// "Dx report" tab label, dotted while a draft is pending; reuses the panel's drafts cache.
export function DxTabLabel({ patientId, noteCount = 0 }: DxTabLabelProps) {
    const { drafts } = useDxReportDrafts(patientId);
    const pendingDraft =
        drafts.find((d) => d.status === 'draft' || d.status === 'pending_review') ?? null;
    const inReview = pendingDraft?.status === 'pending_review';
    return (
        <span className="inline-flex items-center gap-1.5">
            Dx report
            {pendingDraft && (
                <span
                    className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${inReview ? 'bg-blue-500' : 'bg-yellow-400'}`}
                />
            )}
            {noteCount > 0 && <CountPill count={noteCount} tone="attention" />}
        </span>
    );
}
